import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["team"];
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _class;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Store } from 'libx';
import BillingMethod from './BillingMethod';
import PayoutMethod from './PayoutMethod';
import BillingProfile from './BillingProfile';
import Transaction from './Transaction';
import { action, computed } from 'mobx';
import ConfirmDialogState from 'components/ConfirmDialog/ConfirmDialogState';
import { task } from 'mobx-task';
import memoize from 'memoizee';
import { BillingAPI } from './API';
import env from '../misc/env';
import { extractMessageFromError } from '../utils/errorUtil';
import { isMobile } from '../utils/mobileDetect';
import { translate as T } from '../utils/translate';
var BillingStore = (_dec = task.resolved, _dec2 = task.resolved, _dec3 = task.resolved, _dec4 = task.resolved, _dec5 = task.resolved, _dec6 = action.bound, _dec7 = task.resolved, _dec8 = task.resolved, _dec9 = task.resolved, _dec10 = task.resolved, _dec11 = task.resolved, _dec12 = task.resolved, _dec13 = task.resolved, _dec14 = task.resolved, _dec15 = task.resolved, _dec16 = task.resolved, _dec17 = task.resolved, _class = /*#__PURE__*/function (_Store) {
  function BillingStore() {
    var _this;
    _classCallCheck(this, BillingStore);
    _this = _callSuper(this, BillingStore, arguments);
    _this.billingProfiles = _this.collection({
      model: BillingProfile
    });
    _this.billingMethods = _this.collection({
      model: BillingMethod
    });
    _this.payoutMethods = _this.collection({
      model: PayoutMethod
    });
    _this.transactions = _this.collection({
      model: Transaction
    });
    _this.billingAPI = new BillingAPI({
      baseURL: env.BILLING_API,
      getToken: _this.rootStore.authStore.getToken
    });
    _this.deleteBillingMethodDialog = new ConfirmDialogState();
    _this.deletePayoutMethodDialog = new ConfirmDialogState();
    _this.fetchBillingProfile = _this.fetchBillingProfile.wrap(function (fn) {
      return memoize(fn, {
        promise: true,
        length: 2
      });
    });
    _this.fetchBillingProfileForTeam = _this.fetchBillingProfileForTeam.wrap(function (fn) {
      return memoize(fn, {
        promise: true,
        length: 1
      });
    });
    _this.rootStore.sessionStore.onWorkspaceSelected(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.fetchBillingProfile.clear();
            _this.billingProfiles.clear();
            _this.billingMethods.clear();
            _this.payoutMethods.clear();
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    return _this;
  }
  _inherits(BillingStore, _Store);
  return _createClass(BillingStore, [{
    key: "billingProfile",
    get: function get() {
      console.warn('BillingStore.billingProfile getter is deprecated. use individualBillingProfileInstead');
      return this.individualBillingProfile;
    }
  }, {
    key: "individualBillingProfile",
    get: function get() {
      var _this2 = this;
      return this.billingProfiles.find(function (x) {
        return x.workspaceId === _this2.rootStore.sessionStore.workspace.id && x.userId === _this2.rootStore.sessionStore.user.id;
      });
    }
  }, {
    key: "teamBillingProfile",
    value: function teamBillingProfile(teamId) {
      return this.billingProfiles.find(function (x) {
        return x.teamId === teamId;
      });
    }
  }, {
    key: "billingMethodsForIndividual",
    get: function get() {
      var profile = this.individualBillingProfile;
      return profile ? profile.billingMethods.slice() : [];
    }
  }, {
    key: "billingMethodsForTeam",
    value: function billingMethodsForTeam(teamId) {
      var profile = this.teamBillingProfile(teamId);
      return profile ? profile.billingMethods.slice() : [];
    }
  }, {
    key: "transactionsForJob",
    value: function transactionsForJob(ids) {
      ids = ids.filter(function (x) {
        return !isNaN(x);
      });
      return this.transactions.filter(function (x) {
        return ids.includes(x.id);
      });
    }
  }, {
    key: "transactionsForBillingMethod",
    value: function transactionsForBillingMethod(id) {
      return this.transactions.filter(function (x) {
        return x.billingMethodId === id;
      });
    }
  }, {
    key: "busy",
    get: function get() {
      return this.changeDefaultBillingMethod.pending || this.fetchBillingProfile.pending || this.fetchBillingProfileForTeam.pending || this.fetchTransactions.pending || this.addBillingMethodForStripeToken.pending || this.deleteBillingMethod.pending || this.addPayoutMethod.pending || this.deletePayoutMethod.pending || this.showStripeCheckout.pending || this.depositCredit.pending || this.adjustCredit.pending || this.updateBillingMethod.pending;
    }
  }, {
    key: "activate",
    value: function () {
      var _activate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var opts,
          _args2 = arguments;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              opts = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
              if (!opts.teamId) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return", this.fetchBillingProfileForTeam(opts.teamId));
            case 3:
              return _context2.abrupt("return", this.fetchBillingProfile());
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function activate() {
        return _activate.apply(this, arguments);
      }
      return activate;
    }()
    /**
     * Fetches all billing profiles for this user.
     */
  }, {
    key: "fetchAllBillingProfiles",
    value: (function () {
      var _fetchAllBillingProfiles = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this3 = this;
        var individualPromise, teamMembers;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              individualPromise = this.fetchBillingProfile();
              _context3.next = 3;
              return this.rootStore.teamMemberStore.fetchUserTeamMembersByPublicId();
            case 3:
              teamMembers = _context3.sent;
              return _context3.abrupt("return", Promise.all([individualPromise].concat(_toConsumableArray(teamMembers.map(function (tm) {
                return _this3.fetchBillingProfileForTeam(tm.teamId);
              })))));
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function fetchAllBillingProfiles() {
        return _fetchAllBillingProfiles.apply(this, arguments);
      }
      return fetchAllBillingProfiles;
    }())
  }, {
    key: "fetchBillingMethods",
    value: function () {
      var _fetchBillingMethods = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var teamId,
          profile,
          _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              teamId = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : null;
              _context4.next = 3;
              return teamId ? this.fetchBillingProfileForTeam(teamId) : this.fetchBillingProfile();
            case 3:
              profile = _context4.sent;
              return _context4.abrupt("return", profile.billingMethods.slice());
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function fetchBillingMethods() {
        return _fetchBillingMethods.apply(this, arguments);
      }
      return fetchBillingMethods;
    }()
  }, {
    key: "fetchBillingProfile",
    value: function fetchBillingProfile() {
      var workspaceId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.rootStore.sessionStore.workspace.id;
      var userId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.rootStore.sessionStore.user.public_id;
      return this.billingAPI.getMemberBillingProfile(workspaceId, userId).then(this.billingProfiles.set);
    }
  }, {
    key: "fetchBillingProfileForTeam",
    value: function fetchBillingProfileForTeam(teamId) {
      return this.billingAPI.getTeamBillingProfile(teamId).then(this.billingProfiles.set);
    }
  }, {
    key: "fetchTransactions",
    value: function fetchTransactions() {
      var _this4 = this;
      var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      ids = ids.filter(function (x) {
        return !isNaN(x);
      });
      if (ids.length === 0) {
        return;
      }
      return this.billingAPI.getTransactionsByIds(ids).then(/*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(data) {
          var enhancedData;
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this4.enhanceData(data);
              case 2:
                enhancedData = _context5.sent;
                _this4.transactions.set(enhancedData);
              case 4:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        return function (_x) {
          return _ref2.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "getTransactionsForBillingMethod",
    value: function () {
      var _getTransactionsForBillingMethod = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(billingMethodId) {
        var _this5 = this;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", this.billingAPI.getTransactions(billingMethodId).then(/*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(data) {
                  var enhancedData;
                  return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        _context6.next = 2;
                        return _this5.enhanceData(data);
                      case 2:
                        enhancedData = _context6.sent;
                        _this5.transactions.set(enhancedData);
                      case 4:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee6);
                }));
                return function (_x3) {
                  return _ref3.apply(this, arguments);
                };
              }()));
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function getTransactionsForBillingMethod(_x2) {
        return _getTransactionsForBillingMethod.apply(this, arguments);
      }
      return getTransactionsForBillingMethod;
    }()
  }, {
    key: "enhanceData",
    value: function () {
      var _enhanceData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(data) {
        var _this6 = this;
        var enhancedData;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (data.data) {
                data = data.data;
              }
              _context9.next = 3;
              return Promise.all(data.filter(Boolean).map(/*#__PURE__*/function () {
                var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(transaction) {
                  var job;
                  return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) switch (_context8.prev = _context8.next) {
                      case 0:
                        if (!(transaction.metadata && transaction.metadata.job_id)) {
                          _context8.next = 9;
                          break;
                        }
                        job = _this6.rootStore.jobStore.jobs.get(transaction.metadata.job_id);
                        if (job) {
                          _context8.next = 9;
                          break;
                        }
                        _context8.next = 5;
                        return _this6.rootStore.jobStore.getJob(transaction.metadata.job_id);
                      case 5:
                        job = _context8.sent;
                        if (!job.ownerTeamId) {
                          _context8.next = 9;
                          break;
                        }
                        _context8.next = 9;
                        return _this6.rootStore.teamStore.fetchTeam(job.ownerTeamId);
                      case 9:
                        if (!(transaction.metadata && transaction.metadata.user_public_id)) {
                          _context8.next = 12;
                          break;
                        }
                        _context8.next = 12;
                        return _this6.rootStore.memberStore.fetchByPublicId({
                          user_public_id: transaction.metadata.user_public_id,
                          workspace_id: _this6.rootStore.sessionStore.workspace.id
                        });
                      case 12:
                        return _context8.abrupt("return", transaction);
                      case 13:
                      case "end":
                        return _context8.stop();
                    }
                  }, _callee8);
                }));
                return function (_x5) {
                  return _ref4.apply(this, arguments);
                };
              }()));
            case 3:
              enhancedData = _context9.sent;
              return _context9.abrupt("return", enhancedData);
            case 5:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }));
      function enhanceData(_x4) {
        return _enhanceData.apply(this, arguments);
      }
      return enhanceData;
    }()
  }, {
    key: "resetBillingProfiles",
    value: function resetBillingProfiles() {
      this.fetchBillingProfile.clear();
      this.fetchBillingProfileForTeam.clear();
    }
  }, {
    key: "changeDefaultBillingMethod",
    value: function changeDefaultBillingMethod(method, team) {
      var _this7 = this;
      var payload = {
        default_billing_method_id: method.id
      };
      var p = team ? this.billingAPI.updateTeamBillingProfile(team.id, payload) : this.billingAPI.updateMemberBillingProfile(this.individualBillingProfile.workspaceId, payload, this.rootStore.sessionStore.member.userPublicId);
      return p.then(action(this.billingProfiles.set)).catch(function (err) {
        _this7.rootStore.flashMessageStore.create({
          type: 'error',
          message: "Changing default billing method failed: ".concat(extractMessageFromError(err))
        });
        console.error(err);
      });
    }
  }, {
    key: "changeDefaultPayoutMethod",
    value: function changeDefaultPayoutMethod(method, team) {
      var _this8 = this;
      var payload = {
        default_payout_method_id: method.id
      };
      var p = team ? this.billingAPI.updateTeamBillingProfile(team.id, payload) : this.billingAPI.updateMemberBillingProfile(this.individualBillingProfile.workspaceId, payload, this.rootStore.sessionStore.member.userPublicId);
      return p.then(action(this.billingProfiles.set)).catch(function (err) {
        _this8.rootStore.flashMessageStore.create({
          type: 'error',
          message: "Changing default payout method failed: ".concat(extractMessageFromError(err))
        });
        console.error(err);
      });
    }
  }, {
    key: "showStripeCheckout",
    value: function () {
      var _showStripeCheckout = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var _this9 = this;
        var _ref5,
          team,
          opts,
          token,
          _args10 = arguments;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _ref5 = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : {}, team = _ref5.team, opts = _objectWithoutProperties(_ref5, _excluded);
              _context10.next = 3;
              return new Promise(function (resolve) {
                var _this9$rootStore$sess;
                var handler = _this9.handler = checkout({
                  key: ((_this9$rootStore$sess = _this9.rootStore.sessionStore.workspace.config.billing) === null || _this9$rootStore$sess === void 0 ? void 0 : _this9$rootStore$sess.stripe_pk) || env.STRIPE_PK,
                  token: function token(_token) {
                    _this9.handler = null;
                    resolve(_token);
                  },
                  closed: function closed() {
                    _this9.handler = null;
                    setTimeout(function () {
                      resolve(false);
                    }, 100);
                  }
                });
                handler.open(_objectSpread({
                  currency: 'USD',
                  name: T('Web.Common.WorkspaceName', _this9.rootStore.sessionStore.workspace.name),
                  description: 'Add Payment Method',
                  email: _this9.rootStore.authStore.user.email,
                  panelLabel: 'Add'
                }, opts));
              });
            case 3:
              token = _context10.sent;
              return _context10.abrupt("return", this.addBillingMethodForStripeToken(team, token).catch(function (err) {
                _this9.rootStore.flashMessageStore.create({
                  message: parseErrorMessage(err),
                  type: 'error'
                });
                throw err;
              }));
            case 5:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function showStripeCheckout() {
        return _showStripeCheckout.apply(this, arguments);
      }
      return showStripeCheckout;
    }()
  }, {
    key: "redirectToStripeConnect",
    value: function redirectToStripeConnect(team) {
      var ROOT = "".concat(window.location.protocol, "//").concat(window.location.host, "/callback/stripe-connect");
      var STRIPE_URL = "https://connect.stripe.com/oauth/authorize?response_type=code&client_id=".concat(env.STRIPE_CONNECT_ID, "&scope=read_write&state=").concat(window.btoa(JSON.stringify({
        teamId: team ? team.id : null
      })), "&redirect_uri=").concat(ROOT);
      window.location.href = STRIPE_URL;
    }
  }, {
    key: "addBillingMethodForStripeToken",
    value: function () {
      var _addBillingMethodForStripeToken = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11(team, token) {
        var _this10 = this;
        var profile, payload;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              if (token) {
                _context11.next = 2;
                break;
              }
              return _context11.abrupt("return", false);
            case 2:
              if (!team) {
                _context11.next = 8;
                break;
              }
              _context11.next = 5;
              return this.fetchBillingProfileForTeam(team.id);
            case 5:
              _context11.t0 = _context11.sent;
              _context11.next = 11;
              break;
            case 8:
              _context11.next = 10;
              return this.fetchBillingProfile();
            case 10:
              _context11.t0 = _context11.sent;
            case 11:
              profile = _context11.t0;
              payload = {
                type: 'Stripe',
                user_id: profile.userPublicId,
                workspace_id: profile.workspaceId,
                token: token.id,
                team_id: team ? team.id : undefined
              };
              return _context11.abrupt("return", this.billingAPI.addBillingMethod(payload).then(action(this.billingMethods.set)).then(function (method) {
                return _this10.changeDefaultBillingMethod(method, team).then(function () {
                  return method;
                });
              }));
            case 14:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function addBillingMethodForStripeToken(_x6, _x7) {
        return _addBillingMethodForStripeToken.apply(this, arguments);
      }
      return addBillingMethodForStripeToken;
    }()
  }, {
    key: "addPayoutMethod",
    value: function () {
      var _addPayoutMethod = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12(code, team) {
        var profile;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              if (!team) {
                _context12.next = 6;
                break;
              }
              _context12.next = 3;
              return this.fetchBillingProfileForTeam(team.id);
            case 3:
              _context12.t0 = _context12.sent;
              _context12.next = 9;
              break;
            case 6:
              _context12.next = 8;
              return this.fetchBillingProfile();
            case 8:
              _context12.t0 = _context12.sent;
            case 9:
              profile = _context12.t0;
              return _context12.abrupt("return", this.billingAPI.addPayoutMethod({
                type: 'Stripe',
                user_id: profile.userId,
                workspace_id: profile.workspaceId,
                team_id: team ? team.id : undefined,
                code: code
              }).then(action(this.payoutMethods.set)));
            case 11:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function addPayoutMethod(_x8, _x9) {
        return _addPayoutMethod.apply(this, arguments);
      }
      return addPayoutMethod;
    }()
  }, {
    key: "deleteBillingMethod",
    value: function () {
      var _deleteBillingMethod = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee13(method) {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              if (!method.default) {
                _context13.next = 2;
                break;
              }
              return _context13.abrupt("return");
            case 2:
              _context13.next = 4;
              return this.deleteBillingMethodDialog.show();
            case 4:
              if (_context13.sent) {
                _context13.next = 6;
                break;
              }
              return _context13.abrupt("return");
            case 6:
              _context13.prev = 6;
              _context13.next = 9;
              return this.billingAPI.removeBillingMethod(method.id);
            case 9:
              this.billingMethods.remove(method);
              _context13.next = 15;
              break;
            case 12:
              _context13.prev = 12;
              _context13.t0 = _context13["catch"](6);
              this.rootStore.flashMessageStore.create({
                type: 'error',
                message: "".concat(extractMessageFromError(_context13.t0))
              });
            case 15:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this, [[6, 12]]);
      }));
      function deleteBillingMethod(_x10) {
        return _deleteBillingMethod.apply(this, arguments);
      }
      return deleteBillingMethod;
    }()
  }, {
    key: "deletePayoutMethod",
    value: function () {
      var _deletePayoutMethod = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee14(method) {
        var _this11 = this;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              if (!method.default) {
                _context14.next = 2;
                break;
              }
              return _context14.abrupt("return");
            case 2:
              _context14.next = 4;
              return this.deletePayoutMethodDialog.show();
            case 4:
              if (_context14.sent) {
                _context14.next = 6;
                break;
              }
              return _context14.abrupt("return");
            case 6:
              return _context14.abrupt("return", this.billingAPI.removePayoutMethod(method.id).then(action(function () {
                return _this11.payoutMethods.remove(method);
              })));
            case 7:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function deletePayoutMethod(_x11) {
        return _deletePayoutMethod.apply(this, arguments);
      }
      return deletePayoutMethod;
    }()
  }, {
    key: "closeCheckout",
    value: function closeCheckout() {
      if (this.handler) {
        this.handler.close();
      }
    }
  }, {
    key: "addCreditMethod",
    value: function () {
      var _addCreditMethod = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee15(data) {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return this.billingAPI.addBillingMethod(data).then(action(this.billingMethods.set));
            case 2:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function addCreditMethod(_x12) {
        return _addCreditMethod.apply(this, arguments);
      }
      return addCreditMethod;
    }()
  }, {
    key: "depositCredit",
    value: function () {
      var _depositCredit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee16(billingMethodId, data) {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return this.billingAPI.depositCredit(billingMethodId, data).then(this.billingMethods.set);
            case 2:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function depositCredit(_x13, _x14) {
        return _depositCredit.apply(this, arguments);
      }
      return depositCredit;
    }()
  }, {
    key: "adjustCredit",
    value: function () {
      var _adjustCredit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee17(billingMethodId, data) {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return this.billingAPI.adjustCredit(billingMethodId, data).then(this.billingMethods.set);
            case 2:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function adjustCredit(_x15, _x16) {
        return _adjustCredit.apply(this, arguments);
      }
      return adjustCredit;
    }()
  }, {
    key: "updateBillingMethod",
    value: function () {
      var _updateBillingMethod = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee18(billingMethodId, data) {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return this.billingAPI.updateBillingMethod(billingMethodId, data).then(this.billingMethods.set);
            case 2:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function updateBillingMethod(_x17, _x18) {
        return _updateBillingMethod.apply(this, arguments);
      }
      return updateBillingMethod;
    }()
  }]);
}(Store), _applyDecoratedDescriptor(_class.prototype, "billingProfile", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "billingProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "individualBillingProfile", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "individualBillingProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "billingMethodsForIndividual", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "billingMethodsForIndividual"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "busy", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "busy"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activate", [task], Object.getOwnPropertyDescriptor(_class.prototype, "activate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fetchBillingMethods", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "fetchBillingMethods"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fetchBillingProfile", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "fetchBillingProfile"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fetchBillingProfileForTeam", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "fetchBillingProfileForTeam"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fetchTransactions", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "fetchTransactions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getTransactionsForBillingMethod", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "getTransactionsForBillingMethod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resetBillingProfiles", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "resetBillingProfiles"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "changeDefaultBillingMethod", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "changeDefaultBillingMethod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "changeDefaultPayoutMethod", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "changeDefaultPayoutMethod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showStripeCheckout", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "showStripeCheckout"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addBillingMethodForStripeToken", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "addBillingMethodForStripeToken"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addPayoutMethod", [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, "addPayoutMethod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deleteBillingMethod", [_dec12], Object.getOwnPropertyDescriptor(_class.prototype, "deleteBillingMethod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deletePayoutMethod", [_dec13], Object.getOwnPropertyDescriptor(_class.prototype, "deletePayoutMethod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "addCreditMethod", [_dec14], Object.getOwnPropertyDescriptor(_class.prototype, "addCreditMethod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "depositCredit", [_dec15], Object.getOwnPropertyDescriptor(_class.prototype, "depositCredit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "adjustCredit", [_dec16], Object.getOwnPropertyDescriptor(_class.prototype, "adjustCredit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateBillingMethod", [_dec17], Object.getOwnPropertyDescriptor(_class.prototype, "updateBillingMethod"), _class.prototype), _class);
export { BillingStore as default };
/**
 * We're lazy-evaling because we're loading Stripe asynchronously.
 */
function checkout(opts) {
  if (isMobile()) {
    window.StripeCheckout.__app.setForceView('IframeView');
  }
  return window.StripeCheckout.configure(_objectSpread(_objectSpread({}, opts), {}, {
    image: require('assets/img/taxfyle-icon-256px.png'),
    locale: 'auto',
    billingAddress: true,
    zipCode: true
  }));
}

/**
 * Passes through the server error message if it's of a known
 * type. Otherwise, returns a generic message.
 */
function parseErrorMessage(err) {
  var message = extractMessageFromError(err);
  if (/zip code/i.test(message)) {
    return message;
  }
  return 'Oops, something went wrong.';
}
//# sourceMappingURL=BillingStore.js.map
